import React from 'react';
import { Menu, MenuItem, ListItemIcon, ListItemText } from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import EditIcon from '@mui/icons-material/Edit';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';

export interface ImageActionMenuLabels {
  view: string;
  update: string;
  remove: string;
}

interface ImageActionMenuProps {
  anchorEl: HTMLElement | null;
  open: boolean;
  onClose: () => void;
  onView: () => void;
  onUpdate: () => void;
  onRemove: () => void;
  labels?: Partial<ImageActionMenuLabels>;
  /** "Resmi Kaldır" seçeneğini gizlemek için (ör. resim yokken) */
  showRemove?: boolean;
}

const DEFAULT_LABELS: ImageActionMenuLabels = {
  view: 'Resmi Göster',
  update: 'Resmi Güncelle',
  remove: 'Resmi Kaldır',
};

/**
 * Resim işlemleri için yeniden kullanılabilir menü.
 * Ürün/stok ve e-ticaret kategori resimlerinde ortak kullanılır.
 */
const ImageActionMenu: React.FC<ImageActionMenuProps> = ({
  anchorEl,
  open,
  onClose,
  onView,
  onUpdate,
  onRemove,
  labels,
  showRemove = true,
}) => {
  const mergedLabels = { ...DEFAULT_LABELS, ...labels };

  const runAndClose = (action: () => void) => () => {
    onClose();
    action();
  };

  return (
    <Menu
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      transformOrigin={{ vertical: 'top', horizontal: 'center' }}
      PaperProps={{
        elevation: 3,
        sx: { minWidth: 200, borderRadius: 2, mt: 0.5 },
      }}
    >
      <MenuItem onClick={runAndClose(onView)}>
        <ListItemIcon>
          <VisibilityIcon fontSize="small" color="primary" />
        </ListItemIcon>
        <ListItemText primary={mergedLabels.view} />
      </MenuItem>
      <MenuItem onClick={runAndClose(onUpdate)}>
        <ListItemIcon>
          <EditIcon fontSize="small" color="secondary" />
        </ListItemIcon>
        <ListItemText primary={mergedLabels.update} />
      </MenuItem>
      {showRemove && (
        <MenuItem onClick={runAndClose(onRemove)}>
          <ListItemIcon>
            <DeleteOutlineIcon fontSize="small" color="error" />
          </ListItemIcon>
          <ListItemText primary={mergedLabels.remove} primaryTypographyProps={{ color: 'error' }} />
        </MenuItem>
      )}
    </Menu>
  );
};

export default ImageActionMenu;
